"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./RangePicker.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const RangePicker = /*#__PURE__*/React.forwardRef(({
  ranges,
  handleRangeClick,
  defaultIndex = 0,
  pickedRange,
  ...otherProps
}, ref) => {
  const [activeIndex, setActiveIndex] = React.useState(defaultIndex);

  const handleClick = index => () => {
    setActiveIndex(index);
    if (handleRangeClick) handleRangeClick(index);
  };

  React.useEffect(() => {
    if (pickedRange || pickedRange === 0) {
      setActiveIndex(pickedRange);
    }
  }, [pickedRange]);
  return (0, _pragma.createFelaElement)(_.View, _extends({
    css: css.wrapper,
    ref: ref,
    justifyContent: "center"
  }, otherProps), ranges.map((range, index) => (0, _pragma.createFelaElement)(_.View, {
    justifyContent: "center",
    alignItems: "center",
    css: css.item,
    cssProps: {
      isActive: activeIndex === index
    },
    onClick: handleClick(index),
    key: range
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "metaBold",
    lineHeight: "xl",
    size: "s",
    color: activeIndex === index ? 'text.3' : 'text.2'
  }, range))));
});
RangePicker.displayName = 'RangePicker';
var _default = RangePicker;
exports.default = _default;
//# sourceMappingURL=RangePicker.js.map